import { render, staticRenderFns } from "./LeftCard.vue?vue&type=template&id=24582c2b&"
import script from "./LeftCard.vue?vue&type=script&lang=ts&"
export * from "./LeftCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports